import axios from 'axios';

export const getImagePath = (item, threadWebColor) => {
	let imagePath = process.env.REACT_APP_JOSTENS_CDN_HOST + item.imagePath;
	if (item.colorizeFlag === 'n')
		imagePath = imagePath + item.assetId + '/' + item.assetId + '-sm.png';
	else
		imagePath =
			imagePath +
			item.assetId +
			'/' +
			item.assetId +
			'-' +
			threadWebColor +
			'-sm.png';
	return imagePath;
};

export const getAssetsList = (callBack, customerNumber) => {
	let host = process.env.REACT_APP_JOSTENS_STOLE_BUILDER_HOST;
	customerNumber &&
		axios
			.get(`${host}/stoleAsset?customerNumber=${customerNumber}`)
			.then((res) => {
				let schoolAsset = [];
				let graphics = [];
				res && res.data &&
					res.data.forEach((asset) => {
						asset.customerNumber === '-999'
							? graphics.push(asset)
							: schoolAsset.push(asset);
					});
				callBack({ schoolAsset: schoolAsset, graphics: graphics });
			})
			.catch((err) => console.log(err));
};

export const onImageError = (e, item, color, stoleMeta) => {
	let noAsseturl = stoleMeta && stoleMeta.image && stoleMeta.image.noAsset;
	if(e.target.src.includes('no-asset.png')){
		return true
	} else {
		let imagePath =
			process.env.REACT_APP_JOSTENS_CDN_HOST + noAsseturl;
		if(item.colorizeFlag === "y") {
		let sampleData = {
			stoleAsset: { ...item },
			masterColor: { ...color },
		};
		let host = process.env.REACT_APP_JOSTENS_STOLE_BUILDER_HOST;
		axios
			.post(`${host}/colorAsset`, sampleData)
			.then(() => {
				imagePath = getImagePath(item, color.threadWebColor);
				document.getElementById(item.assetId).setAttribute("src", imagePath);
			})
			.catch((error) => {
				console.log(error);
			});
		}
		e.target.onerror = null;
		e.target.src = imagePath;
	}
};

export const setColorValues = (selectedData, colorList, setSelectedTemplate ) => {
	let data =
		selectedData &&
		selectedData.designSettings &&
		selectedData.designSettings.data;
	colorList &&
		colorList.map((color) => {
			if (color.colorId === data.baseColorId) {
				data = {
					...data,
					baseColorName: color.renderColorName,
					baseMfgColorCode: color.baseMfgColorCode,
					baseWebColor: color.baseWebColor,
				};
			}
			if (color.colorId === data.trimColoId) {
				data = {
					...data,
					trimColorName: color.renderColorName,
					trimMfgColorCode: color.trimMfgColorCode,
					trimWebColor: color.trimWebColor,
				};
			}
			if (color.colorId === data.threadColorId) {
				data = {
					...data,
					threadColorName: color.renderColorName,
					threadMfgColorCode: color.threadMfgColorCode,
					threadWebColor: color.threadWebColor,
				};
			}
		});
	let template = { ...selectedData };
	template.designSettings && (template.designSettings.data = data);
	setSelectedTemplate(template);
};